import { Record } from "immutable"

export const schema = {
  light: false,
  highlighted: {},
  container: {},
}

export default Record(schema)



// WEBPACK FOOTER //
// ./src/models/style.model.js